import StoriesModel from "./StoriesModel";
import DesktopStoriesView from "./DesktopStoriesView";
import MobileStoriesView from "./MobileStoriesView";
import Utils from "../../misc/Utils";
import Alert from "../Alert";
import Popups from "../Popups";

class StoriesController {
    constructor() {
        this.$wrapper = jQuery('[data-stories-wrapper]');
        this.isSlider = (this.$wrapper.find('.slider-inner').length > 0);
        this.$sliderInner = this.$wrapper.find('.slider-inner');
        this.isVideoMuted = (Utils.getCookie('_mst', '0') === '1');
        this.mutedIconClass = "mute";
        this.unMutedIconClass = "volume";
        this.model = new StoriesModel(this);
        this.desktopUI = new DesktopStoriesView(this);
        this.mobileUI = new MobileStoriesView(this);
        this.currentUI = null;
        this.desktopBreakPoint = 960;
        this.setCurrentUI();
        this.$thumbWrapper = this.setupStoriesView();
        this.model.getStoriesArray();
        this.initEvents();
        this.getRequestedStory();
    }

    setCurrentUI(){
        if(jQuery(window).width() > this.desktopBreakPoint) {
            this.currentUI = this.desktopUI;
        } else {
            this.currentUI = this.mobileUI;
        }
    }
    getStoryThumb(story) {
        let $storyTemplate = jQuery(jQuery('[data-story-thumb-template]').html());
        let $thumb = $storyTemplate.find('.thumb');
        let $img = $thumb.find('.image-thumb');
        $thumb.attr('href', story.permalink);
        $thumb.attr('title', Utils.esc_attr(story.title));
        $thumb.attr('data-show-story', story.id);
        if(typeof story.extra_class !== 'undefined') {
            $thumb.addClass(story.extra_class);
        }
        if(this.isSlider) {
            $img.attr('src', story.thumbnail);
            $img.attr('alt', Utils.esc_attr(story.title));
        } else {
            $storyTemplate.find('.views .value').text(story.views);
            $storyTemplate.find('.votes-up .value').text(story.votes_up);
            $storyTemplate.find('.votes-down .value').text(story.votes_down);
            $img.css('background-image', "url('" + story.thumbnail + "')")
        }
        return $storyTemplate;
    }
    setupStoriesView() {
        let $thumbWrapper = jQuery('<div class="row tiles"></div>');
        let seen = [];
        if(typeof _stories === 'undefined') {
            return false;
        }
        _stories.forEach((story) => {
            if(this.model.seenIds.indexOf(story.id) !== -1 && this.isSlider) {
                story['extra_class'] = 'seen';
                seen.push(story);
            } else {
                $thumbWrapper.append(this.getStoryThumb(story));
            }
        });
        seen.forEach((story) => {
            $thumbWrapper.append(this.getStoryThumb(story));
        });
        if(this.isSlider) {
            this.$wrapper.find('.slider-inner').append($thumbWrapper);
        } else {
            this.$wrapper.find('.container_box').append($thumbWrapper);
        }
        return $thumbWrapper;
    }
    activateStory() {
        let $thumb = jQuery('[data-show-story="'+this.model.activeStory.id+'"]');
        let $targetStory = jQuery('[data-story-id="'+this.model.activeStory.id+'"]');
        let $targetVideo = $targetStory.find('video');
        $targetStory.addClass('active');
        if($targetVideo.length > 0) {
            $targetVideo.addClass('playing');
            $targetVideo.find('source').attr('src', $targetVideo.find('source').attr('data-src'));
            $targetVideo[0].muted = this.isVideoMuted;
            $targetVideo.get(0).load();
            $targetVideo.get(0).play().catch((e) => {
                $targetVideo.removeClass('playing');
                $targetStory.find('.video-loader').hide();
                $targetStory.find('.video-spinner').hide();
            });
        }
        this.model.pushToSeenIDs();
        if(!$thumb.hasClass('seen')) {
            Utils.commit_ajax_action('view_story', {'id' : this.model.activeStory.id});
        }
        $thumb.addClass('seen');
    }
    deactivateStory() {
        let $targetStory = this.model.activeStory.$el;
        let $targetVideo = $targetStory.find('video');
        $targetStory.removeClass('active');
        if($targetVideo.length > 0) {
            $targetVideo.removeClass('playing');
            $targetVideo.get(0).pause();
            $targetVideo.find('source').attr('src', '');
        }
        if($targetStory.find('.story-popup.open').length > 0) {
            Popups.closePopup();
        }
    }
    onStoriesTraverse(direction){
        let self = this;
        let targetId, idToFetch;
        if(direction === 'prev') {
            targetId = this.model.activeStory.$el.prev().attr('data-story-id');
            idToFetch = this.model.getPreviousStoryId();
            if(idToFetch) {
                this.model.fetchStoriesModalByIds([idToFetch], function (response) {
                    self.currentUI.onFetchStoriesModal(response, true);
                });
            } else {
                this.model.fetchStoriesThumbs(true, function (stories) {
                    if(typeof stories !== 'undefined') {
                        self.currentUI.onFetchStoriesThumbs(stories, true);
                    }
                });
            }
        } else {
            targetId = this.model.activeStory.$el.next().attr('data-story-id');
            idToFetch = this.model.getNextStoryId();
            if(idToFetch) {
                this.model.fetchStoriesModalByIds([idToFetch], function (response) {
                    self.currentUI.onFetchStoriesModal(response, false);
                });
            } else {
                this.model.fetchStoriesThumbs(false, function (stories) {
                    if(typeof stories !== 'undefined') {
                        self.currentUI.onFetchStoriesThumbs(stories, false);
                    }
                });
            }
        }
        if(targetId){
            this.deactivateStory();
            this.model.activeStory.setId(targetId);
            this.activateStory();
            if(this.currentUI.device === 'desktop') {
                this.desktopUI.toggleDirectionControl();
            } else {
                if(jQuery('.stories-swipe').length > 0) {
                    jQuery('.stories-swipe').hide();
                    Utils.setCookie('_hss', '1');
                }
                this.mobileUI.scrollToActive();
            }
        }
    }
    getRequestedStory(){
        let $requestedStory = jQuery('[data-requested-story]');
        if($requestedStory.length > 0) {
            let id = $requestedStory.attr('data-requested-story');
            let adjacentIds = this.model.getAdjacentStoriesIds(id);
            this.model.fetchStoriesModalByIds(adjacentIds,
                (response) =>  {
                    this.currentUI.openStories(id, response);
                }, () => {
                    this.currentUI.closeStories();
                    Alert.showGeneralAlert("There was an error, please try again later");
                });
        }
    }
    onStoriesMuteChange(){
        let $video = this.model.activeStory.$el.find('video');
        let self = this;
        if($video.get(0).muted) {
            jQuery('.stories-modal video').each(function () {
                this.muted = false;
                self.isVideoMuted = false;
                jQuery(this).parents('.stories-modal').find('[data-stories-mute] .icon-custom').removeClass(self.mutedIconClass).addClass(self.unMutedIconClass);
            });
            Utils.removeCookie('_mst');
        } else {
            jQuery('.stories-modal video').each(function () {
                this.muted = true;
                self.isVideoMuted = true;
                jQuery(this).parents('.stories-modal').find('[data-stories-mute] .icon-custom').removeClass(self.unMutedIconClass).addClass(self.mutedIconClass);
            });
            Utils.setCookie('_mst', '1', 365*60);
        }
    }
    initEvents() {
        let self = this;
        this.$wrapper.on('click', '[data-slider-scroll]', function(evt) {
            self.desktopUI.onSliderScroll(evt, jQuery(this));
        });
        this.$sliderInner.on('scroll', () => {
            this.mobileUI.onSliderScroll();
        });
        jQuery.fn.storyVideo = function () {
            let $wrapper = jQuery(this).parents('.stories-modal')
            let $progressTracker = $wrapper.find('.progress-tracker');
            let $bufferingDisplay = $wrapper.find('.buffering-display');
            let buffTimeout = null;
            let buffThreshold = 300; //ms after which the user perceives buffering
            let duration;
            this.on('loadedmetadata', function () {
                duration = this.duration;
            });
            this.on('timeupdate', function () {
                let progress = 100 * (this.currentTime / duration);
                $bufferingDisplay.hide();
                $progressTracker.show();
                $progressTracker.css('width', progress+'%');
            });
            this.on('playing', function () {
                $wrapper.find('.video-loader').hide();
                $wrapper.find('.video-spinner').hide();
                clearTimeout(buffTimeout);
                $bufferingDisplay.hide();
                $progressTracker.show();
            });
            this.on('ended', function () {
                if(Utils.getCookie('_hss', -1) === -1) { //_story_swipe_notice
                    jQuery('.stories-swipe').show();
                }
                this.play().catch(function () {/* blaze it */});
            });
            this.on('waiting', function () {
                buffTimeout = setTimeout(function () {
                    $progressTracker.hide();
                    $bufferingDisplay.show();
                }, buffThreshold);
            });
        };
        jQuery(window).on('resize', () => {
            this.setCurrentUI();
        });
        jQuery('[data-close-stories]').on('click', () => {
            this.currentUI.closeStories();
        });
        jQuery('.body-overlay').on('click', function () {
            if(jQuery('.stories-wrapper').hasClass('open') && self.currentUI.device === 'desktop') {
                self.currentUI.closeStories();
            }
        });
        jQuery('[data-stories-direction]').on('click', function() {
            let direction = jQuery(this).attr('data-stories-direction');
            self.onStoriesTraverse(direction);
        });
        jQuery(document.body)
            .on('click', '.stories-wrapper video, .stories-wrapper .play-wrapper, .stories-wrapper .video-loader',  function () {
                let $video = jQuery(this).parents('.stories-modal').find('video');
                $video.toggleClass('playing');
                if($video.hasClass('playing')) {
                    $video.get(0).play().catch(() => { /*swallow it*/ });
                } else {
                    $video.get(0).pause();
                }
            })
            .on('click', '[data-stories-mute]', () => {
                this.onStoriesMuteChange();
            })
            .on('click', '[data-show-story]', function (evt) {
                evt.preventDefault();
                let id = jQuery(this).attr('data-show-story');
                let adjacentIds = self.model.getAdjacentStoriesIds(id);
                self.model.fetchStoriesModalByIds(adjacentIds,
                    function (response) {
                        self.currentUI.openStories(id, response);
                    }, function () {
                        self.currentUI.closeStories();
                        Alert.showGeneralAlert("There was an error, please try again later");
                    });
            })
            .on('keydown', (evt) => {
                if(jQuery('.stories-wrapper.open').length) {
                    if(evt.keyCode === 37 && this.model.activeStory.arrayIndex > 0) {
                        this.onStoriesTraverse('prev');
                    } else if(evt.keyCode === 39 && this.model.activeStory.arrayIndex < StoriesModel._stories.length - 1) {
                        this.onStoriesTraverse('next');
                    } else if(evt.keyCode === 27) {
                        this.currentUI.closeStories();
                    }
                }
            });
        jQuery('.stories-wrapper')
            .on('touchstart', 'video, .stories-swipe, .img-wrapper, .video-loader', function (evt) {self.mobileUI.onStoryTouchStart(evt);})
            .on('touchmove', 'video, .stories-swipe, .img-wrapper, .video-loader', function (evt) {self.mobileUI.onStoryTouchMove(evt);})
            .on('touchend', 'video, .stories-swipe, .img-wrapper, .video-loader', () => {
                let shouldRevert = this.mobileUI.shouldRevertTransform();
                if(shouldRevert) {
                    this.mobileUI.scrollToActive();
                    return false;
                }
                this.onStoriesTraverse(this.mobileUI.storyTouchEvent['direction']);
            });
    }
}

export default StoriesController;
